module.exports = __webpack_public_path__ + "fontawesome-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.woff?v=4.7.0
// module id = 1516
// module chunks = 14